export default {
  condition: 'Condition',
  conditionGroup: 'Condition group',
  operator: 'Operator',
  not: 'NOT (!)',
  areYouSureYouWantToDeleteThisConsition:
    'Are you sure you want to delete this condition?',
  areYouSureYouWantToDeleteThisConsitionGroup:
    'Are you sure you want to delete this condition group?',
  addCondition: 'Add condition',
  equal: 'Equal (==)',
  notEqual: 'Not equal (!=)',
  greater: 'Greater (>)',
  greaterEqual: 'Greater equal (>=)',
  less: 'Less (<)',
  lessEqual: 'Less equal (<=)',
  and: 'AND (&&)',
  or: 'OR (||)',
  value: 'Value',
  variableName: 'Variable name',
  variable: 'Variable',
  payAttentionOnConditionsDetail: 'Pay attention on conditions detail',
  like: 'Like (LIKE)',
  enableNot: 'Enable NOT',
  disableNot: 'Disable NOT'
}
